exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".el-divider--horizontal[data-v-78db2b76]{margin:4px 0}.fixBar[data-v-78db2b76]{background-color:#fff;width:100%;padding:20px;position:fixed;left:0;right:0;bottom:0;z-index:9;box-shadow:0 -2px 12px 0 hsla(0,0%,88%,.5);text-align:center}", ""]);

// exports
